export const daysOfWeek = (translate: (str: string) => string) => [
  { id: 'SUNDAY', name: translate('daysOfWeek.SUNDAY') },
  { id: 'MONDAY', name: translate('daysOfWeek.MONDAY') },
  { id: 'TUESDAY', name: translate('daysOfWeek.TUESDAY') },
  { id: 'WEDNESDAY', name: translate('daysOfWeek.WEDNESDAY') },
  { id: 'THURSDAY', name: translate('daysOfWeek.THURSDAY') },
  { id: 'FRIDAY', name: translate('daysOfWeek.FRIDAY') },
  { id: 'SATURDAY', name: translate('daysOfWeek.SATURDAY') },
]
